<template>
  <div>
    <div>
      <label class="d-block">Type</label>
      <v-radio-group v-model="form.assign_ticket_type" row hide-details class="ma-0">
        <v-radio
          v-for="type in types"
          :key="type.value"
          :value="type.value"
          :label="type.label"
          color="primary"
        />
      </v-radio-group>
    </div>
    <div class="mt-3">
      <div :style="{ margin: '-4px' }">
        <v-layout align-center>
          <v-flex shrink class="pa-1">
            <ToggleButton
              v-model="form.assign_ticket_no_group"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            />
          </v-flex>
          <v-flex class="pa-1">Assign without group</v-flex>
        </v-layout>
      </div>
      <div :style="{ margin: '-4px' }">
        <v-layout align-center>
          <v-flex shrink class="pa-1">
            <ToggleButton
              v-model="form.ticket_assign_previous_agent"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            />
          </v-flex>
          <v-flex class="pa-1">Assign previous agent</v-flex>
        </v-layout>
      </div>
      <div :style="{ margin: '-4px' }">
        <v-layout align-center>
          <v-flex shrink class="pa-1">
            <ToggleButton
              v-model="form.update_open_ticket"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            />
          </v-flex>
          <v-flex class="pa-1">Update open ticket</v-flex>
        </v-layout>
      </div>
      <div :style="{ margin: '-4px' }">
        <v-layout align-center>
          <v-flex shrink class="pa-1">
            <ToggleButton
              v-model="form.agent_check_in_auto"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            />
          </v-flex>
          <v-flex class="pa-1">Check-in automatically</v-flex>
        </v-layout>
      </div>
    </div>
    <div class="mt-3">
      <v-layout justify-center wrap>
        <v-flex shrink>
          <v-btn outline color="grey" :disabled="isLoading" @click="$emit('close')">{{
            $t('cancel')
          }}</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn depressed color="primary" :loading="isLoading" @click="save">{{
            $t('Save')
          }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import ticket3PageApi from '@/api/ticket3/page'
import { handleApiError } from '@/api/util'
import { mapGetters, mapState, mapActions } from 'vuex'
import { assignmentTypes } from '@/constants/ticket3/ticketConstant'

export default {
  components: { ToggleButton },
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      form: {
        assign_ticket_type: '',
        assign_ticket_no_group: false,
        ticket_assign_previous_agent: false,
        update_open_ticket: false,
        agent_check_in_auto: false,
        ...this.value
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    ...mapState({
      botlist: 'botlist'
    }),
    types() {
      return assignmentTypes
    }
  },
  methods: {
    ...mapActions({
      selectBot: 'selectBot',
      updateBotlist: 'updateBotlist'
    }),
    async save() {
      try {
        this.isLoading = true

        const response = await ticket3PageApi.putTicketConfig({
          data: {
            page_id: this.selectedBot.pageid,
            ticket_config: this.form
          }
        })

        if (response.status === 204) {
          const currentBotIndex = this.botlist.findIndex(
            ({ pageid }) => pageid === this.selectedBot.pageid
          )

          if (currentBotIndex === -1) return

          const newBot = {
            ...this.botlist[currentBotIndex],
            ticket_v3_config: { ...this.form }
          }
          const newBotList = this.botlist.splice(currentBotIndex, 1, newBot)

          this.updateBotlist(newBotList)
          this.selectBot(newBot)

          this.$emit('close')
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/TicketAssignmentManagement.vue